<template>
  <div class="absolut m-0 p-0 top-0 right-0 left-0 bottom-0 w-full flex flex-col items-center">

    <div class="relative mt-5 z-20 text-pink-100 cursor-pointer select-none">
      <svg @click="toggle('settings')" class="w-8 h-8" alt="icon for settings" title="Open Settings">
        <use xlink:href="#cog-wheel"></use>
      </svg>
    </div>

    <div class="relative mt-7 z-20 text-pink-100 cursor-pointer select-none">
      <svg @click="toggle('activity-types')" class="w-8 h-8" alt="icon for activity types" title="Open Activity Types">
        <use xlink:href="#select-activity"></use>
      </svg>
    </div>

    <div class="relative mt-7 z-20 text-pink-100 cursor-pointer select-none">
      <svg @click="toggle('notes')" class="w-8 h-8" alt="icon for notes" title="Open Notes">
        <use xlink:href="#note-icon"></use>
      </svg>
    </div>

    <div class="relative mt-7 z-20 text-pink-100 cursor-pointer select-none">
      <svg @click="toggle('tracked-routes')" class="w-8 h-8" alt="icon for notes" title="Open tracked routes">
        <use xlink:href="#route-dashed"></use>
      </svg>
    </div>

    <div class="relative mt-7 z-20 text-pink-100 cursor-pointer select-none">
      <svg @click="toggle('map-hosts')" class="w-8 h-8" alt="icon for map hosts" title="Open Map Hosts">
        <use xlink:href="#map-host"></use>
      </svg>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Menues',
  methods: {
    toggle (what) {
      this.$store.dispatch('ui/setActiveMenu', what)
    }
  }
}
</script>
